// extracted by mini-css-extract-plugin
module.exports = {"DataStoresDeleteTitle":"DataStoresDeleteTitle_bph-j","DataStoresDeleteSubTitle":"DataStoresDeleteSubTitle_lUYnw"};